/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function i(i){return i&&"getAtOrigin"in i&&"originOf"in i}export{i as isMultiOriginJSONMixin};
